/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import BasicUnit from 'astro/server/unit/basic';

import * as Coords from 'shared/geo/coords';


export default class extends BasicUnit
{
  installPassiveBenefit ()
  {
    for (const neighborCoords of Coords.getNeighborsInRange(this.cass.getCoords(), 1))
    {
      const neighbor = this.getPlanet().getZones().getOne(neighborCoords);

      if (neighbor != null)
      {
        neighbor.getAttributes().enableProjectileShield();
      }

      this.getZone().getAttributes().enableProjectileShield();
    }
  }


}
